import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M6.5 12a5 5 0 1 1 -4.995 5.217l-.005 -.217l.005 -.217a5 5 0 0 1 4.995 -4.783z","key":"svg-0"}],["path",{"d":"M17.5 12a5 5 0 1 1 -4.995 5.217l-.005 -.217l.005 -.217a5 5 0 0 1 4.995 -4.783z","key":"svg-1"}],["path",{"d":"M12 2a5 5 0 1 1 -4.995 5.217l-.005 -.217l.005 -.217a5 5 0 0 1 4.995 -4.783z","key":"svg-2"}]]

const IconCirclesFilled = createReactComponent('filled', 'circles-filled', 'CirclesFilled', __iconNode);

export default IconCirclesFilled;